module.exports = __webpack_public_path__ + "img/top.950ca435.png";